import actionTypes from '../constants/actionTypes';

const initialState = {
  authenticated: false,
  authenticatedTs: new Date().getTime() / 1000,
  token: '',
  expiryTs: 0,
  user: {},
  tokenExtend: {},
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_AUTHENTICATION: {
      const { user } = action;
      return {
        ...state,
        authenticated: true,
        authenticatedTs: new Date().getTime() / 1000,
        token: user.access_token,
        expiryTs: user.expiry_ts,
        user: {
          foodyUid: user.foody_uid,
          username: user.username,
          photos: user.photos,
          name: user.name,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
          uid: user.uid,
        },
      };
    }

    case actionTypes.EXCHANGE_ACCESS_TOKEN: {
      const { accessToken: token, expiryTs } = action.response;
      return {
        ...state,
        token,
        expiryTs,
        authenticatedTs: new Date().getTime() / 1000,
      };
    }

    case actionTypes.EXCHANGE_ACCESS_TOKEN_EXTEND: {
      const { tokenData, targetApp } = action.response;
      const { accessToken: token, expiryTs } = tokenData;
      return {
        ...state,
        tokenExtend: {
          ...state.tokenExtend,
          [targetApp]: {
            token,
            expiryTs,
            authenticatedTs: new Date().getTime() / 1000,
          },
        },
      };
    }

    case actionTypes.RESET_AUTHENTICATION: {
      return initialState;
    }

    default:
      return state;
  }
}

export default authReducer;



// WEBPACK FOOTER //
// ./foody/src/authentication/reducers.js